import { BehaviorSubject } from 'rxjs';
import {
  CellItemType,
  Constants,
  PaymentData} from '@benefitsui/app/pages/billing-page/billing-page.types';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Injectable({
  providedIn: 'root'
})
export class BillingFancyService {
  screenName$ = new BehaviorSubject<string>('list');
  private paymentTableCells: PaymentData[] = [];
  premiumInvoiceData: CellItemType | undefined;
  totalAmount = 0;



  formatAmount(amount: number){
    const currencyPipe = new CurrencyPipe(Defaults.usLocale);
    if (amount) {
      return currencyPipe.transform(amount)?.toString();
    } else {
      return undefined;
    }
  }

  getAmountNumber(amountString: string): number {
    const numberString = this.getNumberString(amountString);
    const numberValue = +numberString;
    return numberValue;
  }

  getNumberString(amountString: string): string {
    const numberString = amountString.replace(/[^.0-9]/g, Constants.StringEmpty);
    return numberString;
  }


  formatDate(dateString: string | undefined): string | null {
    const datePipe = new DatePipe(Defaults.usLocale);
    if (dateString === Constants.StringEmpty || dateString === null) return dateString;
    else return datePipe.transform(dateString, Defaults.dateFormatString);
  }

  formatMonthAndYearDate(dateString: string): string | undefined {
    const dtYear = new Date(dateString).getFullYear();
    const dtMonth = (new Date(dateString)).toLocaleString('default', { month: 'long' });
    return dtMonth + ' ' + dtYear  ;
  }

  totalPaymentLines = 0;
  setTotalPaymentLines(totalPaymentLines: number): void {
    this.totalPaymentLines = totalPaymentLines;
  }

}
